import { reactive, watchEffect, getCurrentInstance, h } from 'vue';
import FacetFilters from '../../js/facetFilters.js';
import termFilter from '../components/_term-filter.vue';
import rangeFilter from '../components/_range-filter.vue';

// a Vue composable wrapper around the FaceFilters class for initializing and updating search filter/facets.


export function useFacets(){

    // expects global search options to be set in index.js


    const internalInstance = getCurrentInstance();
    const global = internalInstance.appContext.config.globalProperties;
    const facetFilters = new FacetFilters(global.$searchFields.facetFields, global.$searchOpts.facetSize);

    const { 
            update,
            defaultSize,
            toggleFilter,
            clearFilters,
            facetQuery,
            aggsQueryObj,
            getActiveFilters,
            isActive,
            // do these really need to be exposed?
            updateFromQueryObj,
            makeTermsStr,
            makeRangeStr
    } = facetFilters;

    const facetGroups = reactive(facetFilters.facetGroups);

    function reactiveUpdate() {
        Object.assign(facetGroups, facetFilters.facetGroups);
        global.$eventBus.emit('update-facets', facetGroups);
    }

    function updateFacets(aggs){
        update(aggs);
        reactiveUpdate();
    }

    function toggleFilterAction(field, value) {
        toggleFilter(field, value);
        global.$eventBus.emit('filter-change');
    }

    function clearFiltersAction() {
        clearFilters();
        global.$eventBus.emit('filter-change');
    }

    async function facetQueryAction(field, queryStr, len){
        const res = await facetQuery(field, queryStr, len);
        reactiveUpdate();
        return res;
    }

    // determines which filter template to use
    const filterComponent = (props) => {
        // default to term
        let Component = termFilter;
        if(props.fg.type === 'range') {
            Component = rangeFilter;
        }
        return h(Component, props)
    }

    return {
        updateFacets,
        facetGroups,
        defaultSize,
        toggleFilterAction,
        clearFiltersAction,
        facetQueryAction,
        aggsQueryObj,
        getActiveFilters,
        isActive,
        updateFromQueryObj,
        makeTermsStr,
        makeRangeStr,
        filterComponent
    };
}

